import { createClient, SupabaseClient } from '@supabase/supabase-js';

let supabase: SupabaseClient;

export const getSupabaseClient = () => {
  if (!supabase) {
    if (!import.meta.env.VITE_SUPABASE_URL) {
      throw new Error('Missing VITE_SUPABASE_URL environment variable');
    }

    if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
      throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
    }

    // Create the Supabase client with the correct configuration
    supabase = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SUPABASE_ANON_KEY,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          flowType: 'pkce',
        },
        global: {
          headers: {
            'X-Client-Info': 'architect-frontend',
          },
        },
      }
    );
  }
  return supabase;
}
